import React from "react";

import BotaoVoltar from "./components/BotaoVoltar";
import LogUtil from "./util/LogUtil";
import WPPaginaDAO from "./dataAccess/WP/WPPaginaDAO";
import Carregando from "./components/Carregando";
import Rodape from "./components/Rodape";

type AjudaPagPolPrivProps = {};

type AjudaPagPolPrivState = {
  carregando: boolean;
  titulo: string;
  conteudo: string;
  concluido: boolean;
};

class AjudaPagPolPriv extends React.Component<
  AjudaPagPolPrivProps,
  AjudaPagPolPrivState
> {
  constructor(props: AjudaPagPolPrivProps) {
    super(props);

    this.state = {
      carregando: false,
      titulo: "",
      conteudo: "",
      concluido: false,
    };
  }

  componentDidMount(): void {
    LogUtil.logPage("Ajuda / Pagina / Política privacidade");

    this.setState({ carregando: true });

    WPPaginaDAO.getInstance()
      .getPolPrivOba()
      .then((privacidade: any) => {
        this.setState({
          titulo: privacidade[0].titulo,
          conteudo: privacidade[0].conteudo,
          carregando: false,
          concluido: true,
        });
      });
  }

  render(): any {
    const { carregando, concluido, titulo, conteudo } = this.state;

    return (
      <section className="help">
        <div className="header">
          <BotaoVoltar titulo={titulo}></BotaoVoltar>
        </div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: conteudo }}
        ></div>
        <Rodape parent={this} ativo="Menu"></Rodape>
        <Carregando exibir={carregando} concluido={concluido} />
      </section>
    );
  }
}

export default AjudaPagPolPriv;
